import React from 'react'
import Tab from 'Components/DesignSystem/Tab/Tab';
import { ALL, TOP_25, CURATED } from '../constants/CategoryRelevancyConstants';

type TabsProps = {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
}

const TAB_CONFIG: { key: TabType; label: string }[] = [
    { key: 'all', label: ALL },
    { key: 'top25', label: TOP_25 },
    { key: 'curated', label: CURATED },
];

const Tabs = ({ activeTab, onTabChange }: TabsProps) => {
    return (
        <Tab
            tabs={TAB_CONFIG.map(({ key, label }) => ({
                id: key,
                label,
                'data-testid': `category-relevancy-tab-${key}`,
            }))}
            activeTabId={activeTab}
            onChange={(tabId) => onTabChange(tabId as TabType)}
            data-testid="category-relevancy-tabs"
        />
    );
}

export default Tabs;
